import { createLucideIcon } from './lucideIcon'

export const Plus = createLucideIcon(
  'Plus',
  <>
    <path d="M5 12h14" />
    <path d="M12 5v14" />
  </>
)
